<template>
    <footer class="bg-budgets-darkgray-dark pt-16 pb-8">
        <Container>
            <div class="lg:grid lg:grid-cols-12 lg:gap-12">
                <div class="lg:col-span-5 space-y-8">
                    <svg class="w-9 h-9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" fill="#35c9de" r="256" data-original="#1CE8B7" data-old_color="#1ce8b7"/>
                        <path d="M511.822 265.084L314.851 68.113l.739 25.654-26.879-26.879-60.497 106.817-78.762 53.541 33.234 33.234-20.357 28.699-52.697-52.697 20.744 97.745-26.661 37.585 139.887 139.887c4.108.193 8.24.301 12.398.301 138.343 0 251.036-109.741 255.822-246.916z" fill="#2eb5c8" data-original="#1DCC9E" data-old_color="#1dcc9e"/>
                        <path d="M431.726 301.68l-37.304-33.293-14.914 16.711-18.698-35.489-44.236 23.306 27.397 52.001-10.625 11.905-44.635 12.201v-67.377l76.658-50.621 41.038 7.273 8.726-49.233-28.634-5.074 8.694-26.623-47.529-15.522-17.051 52.213-41.902 27.669v-70.849l56.438-42.991-30.298-39.774-26.14 19.911V66.887h-65v92.646l-52.083-51.93-35.303 35.408 22.545 22.478-33.016 17.675 23.599 44.081 46.427-24.855 27.831 27.749v91.568l-53.416-13.142 29.447-48.238-42.677-26.052-20.866 34.182-26.567-31.977-38.459 31.952 40.633 48.908-22.145 6.485 14.054 47.985 52.206-15.29 67.79 16.677v57.096h65v-29.437l59.805-16.347 72.249 11.209 7.665-49.409-32.091-4.979z" fill="#f7fafc" data-original="#FF6155" data-old_color="#ff6155"/>
                        <path d="M431.726 301.68l-37.304-33.293-14.914 16.711-18.698-35.489-44.236 23.306 27.397 52.001-10.625 11.905-44.635 12.201v-67.377l76.658-50.621 41.038 7.273 8.726-49.233-28.634-5.074 8.694-26.623-47.529-15.522-17.051 52.213-41.902 27.669v-70.849l56.438-42.991-30.298-39.774-26.14 19.911V66.887h-33.116v363.406h33.116v-29.437l59.805-16.347 72.249 11.209 7.665-49.409-32.091-4.979z" fill="#e3e9f0" data-original="#ED2415" class="active-path" data-old_color="#ed2415"/>
                    </svg>
                    <p class="text-gray-body-400 my-0 text-sm leading-6 tracking-wide"
                        v-html="$t('budgets_landing_page.reefkig_solutions_footer_tagline', {
                            lineBreak: '<br/>',
                        })">
                    </p>
                    <div class="flex space-x-6">
                        <a href="https://facebook.com/reefkig" class="hover:text-gray-400 plain text-gray-500" target="_blank" rel="noopener noreferrer">
                            <span class="sr-only">Facebook</span>
                            <svg class="h-18px w-18px" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                            </svg>
                        </a>
                        <a href="https://ro.linkedin.com/company/reefkig-solutions" class="hover:text-gray-400 plain text-gray-500" target="_blank" rel="noopener noreferrer">
                            <span class="sr-only">LinkedIn</span>
                            <svg class="h-18px w-18px" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                            </svg>
                        </a>
                        <a href="https://youtube.com/@reefkigsolutions362" class="hover:text-gray-400 plain text-gray-500" target="_blank" rel="noopener noreferrer">
                            <span class="sr-only">YouTube</span>
                            <svg class="h-18px w-18px" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="lg:grid lg:grid-cols-3 lg:col-span-7 lg:gap-12 lg:space-y-0 lg:mt-0 mt-12 space-y-12">
                    <div>
                        <h3 class="text-gray-body text-sm font-semibold leading-6 my-1.5 tracking-wider uppercase">
                            {{ $t('budgets_landing_page.solutions') }}
                        </h3>
                        <ul role="list" class="mt-6 space-y-4">
                            <li>
                                <a href="https://reefkig.com" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    Reefkig Budgets
                                </a>
                            </li>
                            <li>
                                <a href="https://crm.reefkig.com" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    Reefkig CRM
                                </a>
                            </li>
                            <li>
                                <a href="https://tasks.reefkig.com" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    Reefkig Tasks
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 class="text-gray-body text-sm font-semibold leading-6 my-1.5 tracking-wider uppercase">
                            {{ $t('budgets_landing_page.other_pages') }}
                        </h3>
                        <ul role="list" class="mt-6 space-y-4">
                            <li>
                                <a href="/budgets/updates" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    {{ $t('globals.updates') }}
                                </a>
                            </li>
                            <li>
                                <a href="/terms-and-conditions" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    {{ $t('globals.terms_and_conditions') }}
                                </a>
                            </li>
                            <li>
                                <a href="/privacy-policy" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    {{ $t('globals.privacy_policy') }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 class="text-gray-body text-sm font-semibold leading-6 my-1.5 tracking-wider uppercase">
                            {{ $t('globals.contact') }}
                        </h3>
                        <ul role="list" class="mt-6 space-y-6">
                            <li class="flex flex-col space-y-1">
                                <div class="text-sm font-medium leading-6 text-gray-200">
                                    {{ $t('budgets_landing_page.email') }}
                                </div>
                                <a href="mailto:contact@reefkig.com" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    contact@reefkig.com
                                </a>
                            </li>
                            <li class="flex flex-col space-y-1">
                                <div class="text-sm font-medium leading-6 text-gray-200">
                                    {{ $t('budgets_landing_page.phone') }}
                                </div>
                                <a href="tel:0040753118428" class="hover:text-gray-200 text-sm leading-6 text-gray-400">
                                    +40 753 118 428
                                </a>
                            </li>
                            <li class="flex flex-col space-y-1">
                                <div class="text-sm font-medium leading-6 text-gray-200">
                                    {{ $t('budgets_landing_page.address') }}
                                </div>
                                <div class="text-sm leading-6 text-gray-400">
                                    077015 Sat Balotești,<br/>
                                    Prelungirea Fieni, Nr. 1B/3B,<br/>
                                    Camera 5, Județ Ilfov
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="border-budgets-darkgray-light md:flex-row md:space-y-0 flex flex-col items-center justify-between pt-8 mt-16 space-y-4 border-t">
                <p class="text-gray-body mb-0 tracking-wide" v-html="$t('globals.copyright', {
                    year: new Date().getFullYear(),
                    holder: 'Reefkig Solutions SRL',
                })"></p>
                <LanguageSelect
                    :languages="languages"
                    :on-dark-background="true">
                </LanguageSelect>
            </div>
        </Container>
    </footer>
</template>

<script>
import Container from '../../../../shared/container.vue';
import LanguageSelect from '../../../language-select.vue';

export default {
    components: {
        Container,
        LanguageSelect,
    },

    props: {
        languages: {
            type: Object,
            required: true,
        },
    },
};
</script>
